"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabbedContentContainer = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const layout_1 = require("../layout");
function TabbedContentContainer({ tabs, activeTabKey, dataTestId, }) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(layout_1.Box, Object.assign({ minHeight: "1px", "data-testid": dataTestId }, { children: (0, jsx_runtime_1.jsx)(ContentWrapper, { children: (_a = tabs.find(tab => tab.key === activeTabKey)) === null || _a === void 0 ? void 0 : _a.content }) })));
}
exports.TabbedContentContainer = TabbedContentContainer;
const ContentWrapper = styled_1.default.div(({ theme }) => ({
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: `${theme.spacing.m} ${theme.spacing.xxs} ${theme.spacing.xxs} ${theme.spacing.xxs}`,
}));
//# sourceMappingURL=tabbed_content_container.js.map